import React from 'react';
import { Icon } from '../../../components/common/icon/icon';

import { NewIconNames } from '../../../components/common/icon/new-icon-names';
import { NAVIGATION } from '../../../config';
import i18n from '../../../utils/i18n/i18n';
import styles from './sidebar-footer.scss';

import { Box, Sidebar, TextButton } from '@wix/design-system';

export const SidebarFooter = () => (
  <Sidebar.PersistentFooter>
    <Box align="center" margin="18px 0">
      <TextButton
        as="a"
        href={NAVIGATION.SUPPORT_URL}
        target="_blank"
        prefixIcon={
          <Icon
            name={NewIconNames.InfoCircle}
            fontSize={20}
            className={styles.infoIcon}
          />
        }
      >
        {i18n.t('sidebar.footer-link')}
      </TextButton>
    </Box>
  </Sidebar.PersistentFooter>
);
